<section
	class="flex flex-row gap-6 items-center justify-start border-b border-gray-200 pb-6"
>
	<div>
		<img
			class="w-14 h-16"
			src="/assets/images/integrations/sign-it/sign-it-badge.svg"
			alt="SignIT Logo"
		/>
	</div>
	<div>
		<p class="text-gray-950 text-lg font-medium mb-1">
			Connect to SignIT powered by DocuSign
		</p>
		<p class="text-sm leading-6 text-gray-700">
			Your first 3 sends are free — then just
			{{ integrationCost }}
			per signed package
		</p>
	</div>
</section>

<section class="text-start flex flex-col gap-6 items-start px-4 pt-6">
	<p class="text-gray-700 text-base">
		<span>By selecting “Agree & Connect”, you accept the </span>
		<a
			target="_blank"
			class="text-green-600 underline decoration-green-600"
			href="https://d2eqe1zftj40gd.cloudfront.net/wp-content/uploads/2023/11/22135532/General-Terms-Canada.pdf"
		>
			Licensing Agreement
		</a>
		<span>and acknowledge the following: </span>
	</p>

	<ul class="list-disc ml-5 px-4 flex flex-col gap-8 text-start items-start">
		@for (disclaimer of disclaimers; track $index) {
			<li class="text-gray-700">{{ disclaimer }}</li>
		}
	</ul>
</section>
